<template>
  <div class="button" :class="{
    'button--alternative': alternative,
  }">
    <component class="button__content animated pulse infinite"
      :is="component"
      v-bind="$attrs"
      v-on="$listeners"
      :target="$attrs.to ? undefined : '_blank'"
    >
      <slot />
    </component>
  </div>
</template>

<script>
export default {
  name: 'VButton',
  inheritAttrs: false,

  props: {
    alternative: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    component() {
      return this.$attrs.to ? 'router-link' : 'a';
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  &:not(:first-child) {
    margin-top: calc($gridGutter * 2);
  }

  &,
  &__content {
    display: block;
    width: 100%;
  }

  &__content {
    padding: $gridGutter $gridGutter calc($gridGutter - 5px);

    font-family: $fontFamily;
    font-size: font($buttonFontSizeMin, $buttonFontSizeMax);
    line-height: 1.25em;
    text-decoration: none;
    text-align: center;
    text-transform: uppercase;
    color: #f9f9f9;

    background-color: #1a1109;

    border-radius: 10px;

    box-shadow: 3.5px 3.5px 6px 1.1px #161616;

    cursor: pointer;

    &:hover {
      background-color: #2f1e10;
      // color: $buttonColorHover;
    }
  }

  &--alternative &__content {
    background-color: #2b1a0d;

    &:hover {
      background-color: #1a1109;
    }
  }
}
</style>
